module.exports = __webpack_public_path__ + "img/catchbasin_stopped.9419c35a.svg";